/* global G */
import { curry } from 'lib/util'
import routeComposition from 'trait/composition/route'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'

/**
 * Event Handler Create Redirect
 *
 * Redirects to the route stated inside action.ui.create.
 *
 * @param {Object} module             the current module composition object
 * @param {Object} component          the current component
 * @param {Object} event              the fired event
 * @param {Object} event.detail       the fired event's detail
 * @param {Object} event.detail.route the route to redirect to whenever this event is fired
 * @returns {Promise<void>}
 */
const createRedirect = async (module, component, event) => {
  try {
    const moduleState = module[G.STATE]
    const { route } = event.detail
    moduleState[G.ROUTE] = routeComposition(route.module, route.action)
    await redirectSequence(module)({})
  } catch (e) {
    console.error(e)
  }
}

export default curry(createRedirect)
